<script setup lang="ts">
  import { useVModel } from '@vueuse/core'
  import { ref, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<{
    defaultValue?: string | number
    modelValue?: string | number
    maxLength?: number
    class?: HTMLAttributes['class']
  }>()

  const emits = defineEmits<{
    (e: 'update:modelValue', payload: string | number): void
  }>()

  const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: props.defaultValue
  })

  const inputRef = ref<HTMLInputElement | null>(null)

  defineExpose({
    focus: () => inputRef.value?.focus(),
    inputRef
  })
</script>

<template>
  <input
    ref="inputRef"
    v-model="modelValue"
    data-slot="input"
    :maxLength="props.maxLength"
    :class="
      cn(
        'file:text-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base outline-none transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-neutral-400 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:placeholder:text-neutral-500 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'read-only:bg-muted/50 read-only:focus-visible:border-input read-only:focus-visible:ring-0',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        props.class
      )
    "
  />
</template>
